import { Component, input } from '@angular/core';
import { NgpFormField, NgpLabel } from 'ng-primitives/form-field';

export type JoiiSwitchFormFieldPosition = 'left' | 'right';

@Component({
  selector: 'joii-switch-form-field',
  imports: [NgpFormField, NgpLabel],
  styles: `
    [ngpFormField] {
      display: flex;
      align-items: center;
      gap: var(--Vetai-Spacing-2-5);
    }

    [ngpLabel] {
      color: var(--Vetai-Texts--Base);
      font-weight: var(--Vetai-Font-Weight-Regular);
      font-size: var(--Vetai-T4);
      line-height: var(--Vetai-20);
      font-family: var(--Vetai-Font-Family);
      letter-spacing: var(--Vetai-8-16);
      font-kerning: none;
      font-style: normal;
    }
  `,
  template: `
    <div ngpFormField>
      @if (labelPosition() === 'left') {
        <label ngpLabel>{{ label() }}</label>
      }
      <ng-content select="[slot=switch]" />
      @if (labelPosition() === 'right') {
        <label ngpLabel>{{ label() }}</label>
      }
    </div>
  `,
})
export class SwitchFormFieldComponent {
  label = input<string>('');
  labelPosition = input<JoiiSwitchFormFieldPosition>('left');
}
